import React from "react";
import { Page, List, ListItem } from "react-onsenui";
import Toolbar from "../components/Toolbar";

import ThreatPage from "./ThreatPage";
import BadTrip from "../components/help/BadTrip";
import CardiacArrest from "../components/help/CardiacArrest";
import HeatStroke from "../components/help/HeatStroke";
import Found from "../components/help/Found";
import Psychotic from "../components/help/Psychotic";
import Seizures from "../components/help/Seizures";
import SerotoninSyndrome from "../components/help/SerotoninSyndrome";
import Shock from "../components/help/Shock";
import Unconsciousness from "../components/help/Unconsciousness";

class HelpPage extends React.Component {
  pushThreatPage(threat) {
    this.props.navigator.pushPage({
      component: ThreatPage,
      props: {
        key: threat[0],
        threat: threat
      }
    });
  }

  renderToolbar() {
    const { navigator, showMenu } = this.props;
    return (
      <Toolbar pageName="Help" navigator={navigator} showMenu={showMenu} />
    );
  }

  render() {
    let threatList = [
      ["Bad Trip", <BadTrip />],
      ["Breathing / Cardiac Arrest", <CardiacArrest />],
      ["Heat Stroke", <HeatStroke />],
      ["If you find someone", <Found />],
      ["Psychotic States", <Psychotic />],
      ["Seizures", <Seizures />],
      ["Serotonin Syndrome", <SerotoninSyndrome />],
      ["Shock", <Shock />],
      ["Unconsciousness", <Unconsciousness />]
    ];

    return (
      <Page
        renderToolbar={this.renderToolbar.bind(this)}
      >
        <List
          dataSource={threatList}
          renderRow={threat => {
            return (
              <ListItem
                key={threat[0]}
                onClick={() => this.pushThreatPage(threat)}
                tappable
                className="clickable"
              >
                <div className="testdrugs-header">{threat[0]}</div>
              </ListItem>
            );
          }}
        />
      </Page>
    );
  }
}

export default HelpPage;
